import { TransformedOption } from '../transformers/option'
import { HorizonOption } from '../types'

export const sortOptionsByTheme = (props: {
  options: HorizonOption[]
  themeOrderOverride?: number[]
}) => {
  if (
    !props.themeOrderOverride ||
    props.themeOrderOverride.length !== props.options.length
  ) {
    const optionKeys = props.options.map((option) => option.key)
    return { sortedOptions: props.options, sortedOptionKeys: optionKeys }
  }

  return props.options.reduce<{
    sortedOptions: HorizonOption[]
    sortedOptionKeys: string[]
  }>(
    (accumulator, option, index) => {
      if (props.themeOrderOverride) {
        accumulator.sortedOptions[props.themeOrderOverride[index]] = option
        accumulator.sortedOptionKeys[props.themeOrderOverride[index]] =
          option.key
      }
      return accumulator
    },
    { sortedOptions: [], sortedOptionKeys: [] },
  )
}

export const sortOptions = (props: {
  options: HorizonOption[] | TransformedOption[]
  orderedOptionKeys: string[]
}) => {
  if (props.options.length !== props.orderedOptionKeys.length) {
    return props.options
  }

  const optionMap = props.options.reduce<
    Record<string, HorizonOption | TransformedOption>
  >((accumulator, option) => {
    accumulator[option.key] = option
    return accumulator
  }, {})

  return props.orderedOptionKeys.reduce<HorizonOption[] | TransformedOption[]>(
    (accumulator, optionKey) => {
      const option = optionMap[optionKey]

      if (option) {
        accumulator.push(option)
      }
      return accumulator
    },
    [],
  )
}

export const sortPersonalisationFieldsByOrder = (
  data,
  sortOrder?: string[],
) => {
  if (!data || !sortOrder) {
    return
  }
  return data.sort((a, b) => {
    return sortOrder.indexOf(a.name) - sortOrder.indexOf(b.name)
  })
}
